import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';
import type { NodeCfg } from '../nodes';

export const goToTabNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('goToTab'),
    controlValues: z.object({
        tabGroupDetails: z.object({
            /** the id of the tabGroup linked grid cell */
            id: z.string(),
            /**
             * set when a tab group is selected, or refreshed. mainly for convenience with creating the sockets
             */
            tabs: z.array(z.object({
                tabIndex: z.number(),
            })),
        }),
    }),
});
export type GoToTabNodeCfgSchema = z.infer<typeof goToTabNodeCfgSchema>;

export const goToTabNodeSocketCfg = {
    controlSockets: {
        outputs: () => ({ next: 'event' }),
        inputs: (cfg: NodeCfg<'goToTab'>) => {
            const ret: Record<`${number}`, 'event'> = {};
            for (const tabIdx of cfg.controlValues.tabGroupDetails.tabs) {
                ret[`${tabIdx.tabIndex}`] = 'event';
            }
            return ret;
        },
    },
    dataSockets: {
        inputs: (_cfg: NodeCfg<'goToTab'>) => ({}),
        outputs: (_cfg: NodeCfg<'goToTab'>) => {
            const ret: Record<'activeTabIndex', 'number'> = {
                activeTabIndex: 'number',
            };
            return ret;
        },
    },
} satisfies NodeSocketCfg<GoToTabNodeCfgSchema>;
